<script setup lang="ts">
defineOptions({
	name: "school.class-management",
});
definePage({
	name: "school.class-management",
	path: "/school/class-management",
	redirect: "/school/class-management/class-requests",
});
</script>

<template>
	<router-view></router-view>
</template>
